import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { UPDATE_NOTE, UPDATE_NOTE_MSB } from '@/graphql/mutations/vocabulary';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import qs from 'qs';

import logger from '@/modules/Logger';

export const UpdateVocabularyNoteService = {
  msb: async (params) => {
    logger.debug(`[Vocabulary][Note] Update note using MSB GraphQL endpoint`, {
      operation: 'vocabulary:update-note'
    });

    await myStageApolloProvider.defaultClient
      .mutate({
        mutation: UPDATE_NOTE_MSB,
        variables: {
          id: params.id,
          notes: params.note
        }
      })
      .catch((error) => {
        logger.error('[Vocabulary][Note] Error on updating note', {
          operation: 'vocabulary:update-note',
          error: error.message
        });
        throw error;
      });
  },
  
  mbti: async (params) => {
    logger.debug(`[Vocabulary][Note] Update note using MBTI GraphQL endpoint`, {
      operation: 'vocabulary:update-note'
    });

    await apolloProvider.defaultClient
      .mutate({
        mutation: UPDATE_NOTE,
        variables: {
          id: params.id,
          notes: params.note
        }
      })
      .catch((error) => {
        logger.error('[Vocabulary][Note] Error on updating note', {
          operation: 'vocabulary:update-note',
          error: error.message
        });
        throw error;
      });
  },

  legacy: async (params) => {
    logger.debug(`[Vocabulary][Note] Update note using legacy endpoint`, {
      operation: 'vocabulary:update-note'
    });

    await bizmatesWordbookApi.put('word/note', qs.stringify(params), (err) => err);
  }
};
